import React from 'react';
import Svg, { Defs, LinearGradient, Stop, Text as SvgText } from 'react-native-svg';

import { useSvgId } from '../../../utils/hooks/useSvgId';
import { EVENT_FONT_CONDENSED } from './eventTheme';

// Same trick as the shared GoldGradientText - RN's Text cannot fill glyphs with a gradient, so
// the label is drawn twice, shadow first. This variant takes its own stops: the hero title runs
// a warmer ramp than the app's gold text (it bottoms out in burnt orange, not gold).
const SHADOW_COLOR = 'rgba(0,0,0,0.8)';

type Props = {
	text: string;
	stops: Array<[string, string]>;
	width: number;
	height: number;
	fontSize: number;
	fontFamily?: string;
	fontWeight?: string;
};

export const EventGradientText = ({
	text,
	stops,
	width,
	height,
	fontSize,
	fontFamily = EVENT_FONT_CONDENSED,
	fontWeight = '900',
}: Props) => {
	const gradientId = useSvgId('eventGradientText');
	const baseline = height / 2 + fontSize * 0.35;
	const shared = {
		fontFamily,
		fontSize,
		fontWeight,
		textAnchor: 'middle' as const,
	};

	return (
		<Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
			<Defs>
				<LinearGradient id={gradientId} x1='0' y1='0' x2='0' y2='1'>
					{stops.map(([offset, color]) => (
						<Stop key={offset} offset={offset} stopColor={color} />
					))}
				</LinearGradient>
			</Defs>
			<SvgText {...shared} x={width / 2} y={baseline + 1} fill={SHADOW_COLOR}>
				{text}
			</SvgText>
			<SvgText {...shared} x={width / 2} y={baseline} fill={`url(#${gradientId})`}>
				{text}
			</SvgText>
		</Svg>
	);
};

export default EventGradientText;
